export default {
  //get all CHAPTERs
  GET_COURSES_REQUEST: "GET_COURSES_REQUEST",
  GET_COURSES_SUCCESS: "GET_COURSES_SUCCESS",
  GET_COURSES_FAIL: "GET_COURSES_FAIL",

  //edit CHAPTERs
  EDIT_COURSE_REQUEST: "EDIT_COURSE_REQUEST",
  EDIT_COURSE_SUCCESS: "EDIT_COURSE_SUCCESS",
  EDIT_COURSE_FAIL: "EDIT_COURSE_FAIL",

  RESTRICT_COURSE_REQUEST: "RESTRICT_COURSE_REQUEST",
  RESTRICT_COURSE_SUCCESS: "RESTRICT_COURSE_SUCCESS",
  RESTRICT_COURSE_FAIL: "RESTRICT_COURSE_FAIL",

  ASQUARA_COURSE_REQUEST: "ASQUARA_COURSE_REQUEST",
  ASQUARA_COURSE_SUCCESS: "ASQUARA_COURSE_SUCCESS",
  ASQUARA_COURSE_FAIL: "ASQUARA_COURSE_FAIL",
  ACTIVE_COURSE_REQUEST: "ACTIVE_COURSE_REQUEST",
  ACTIVE_COURSE_SUCCESS: "ACTIVE_COURSE_SUCCESS",
  ACTIVE_COURSE_FAIL: "ACTIVE_COURSE_FAIL",

  //create CHAPTER
  CREATE_COURSE_REQUEST: "CREATE_COURSE_REQUEST",
  CREATE_COURSE_SUCCESS: "CREATE_COURSE_SUCCESS",
  CREATE_COURSE_FAIL: "CREATE_COURSE_FAIL",

  DELETE_COURSE_REQUEST: "DELETE_COURSE_REQUEST",
  DELETE_COURSE_SUCCESS: "DELETE_COURSE_SUCCESS",
  DELETE_COURSE_FAIL: "DELETE_COURSE_FAIL",

  GET_COURSE_REQUEST: "GET_COURSE_REQUEST",
  GET_COURSE_SUCCESS: "GET_COURSE_SUCCESS",
  GET_COURSE_FAIL: "GET_COURSE_FAIL",

  APPROVE_SUPERADMIN_STUDENT_ENROLL_COURSE_REQUEST:
    "APPROVE_SUPERADMIN_STUDENT_ENROLL_COURSE_REQUEST",
  APPROVE_SUPERADMIN_STUDENT_ENROLL_COURSE_SUCCESS:
    "APPROVE_SUPERADMIN_STUDENT_ENROLL_COURSE_SUCCESS",
  APPROVE_SUPERADMIN_STUDENT_ENROLL_COURSE_FAIL:
    "APPROVE_SUPERADMIN_STUDENT_ENROLL_COURSE_FAIL",

  REJECT_SUPERADMIN_STUDENT_ENROLL_COURSE_REQUEST:
    "REJECT_SUPERADMIN_STUDENT_ENROLL_COURSE_REQUEST",
  REJECT_SUPERADMIN_STUDENT_ENROLL_COURSE_SUCCESS:
    "REJECT_SUPERADMIN_STUDENT_ENROLL_COURSE_SUCCESS",
  REJECT_SUPERADMIN_STUDENT_ENROLL_COURSE_FAIL:
    "REJECT_SUPERADMIN_STUDENT_ENROLL_COURSE_FAIL",

  GET_STUDENT_ENROLL_COURSE_REQUEST: "GET_STUDENT_ENROLL_COURSE_REQUEST",
  GET_STUDENT_ENROLL_COURSE_SUCCESS: "GET_STUDENT_ENROLL_COURSE_SUCCESS",
  GET_STUDENT_ENROLL_COURSE_FAIL: "GET_STUDENT_ENROLL_COURSE_FAIL",

  //loading
  ADD_COURSES_LOADING: "ADD_COURSES_LOADING",
};
